import * as _4 from 'lodash4';
import { MajorProgram } from './../builders/major_programs_builder';
import { MajorCurrentMajorsQuery } from './../queries/major_current_majors_query';
import { MajorProgramsQuery } from './../queries/major_programs_query';

export class MajorService {
  constructor(
    private ngMajorProgramsQuery: MajorProgramsQuery,
    private ngMajorCurrentMajorsQuery: MajorCurrentMajorsQuery
  ) {}

  isCurrentMajor(id: number): boolean {
    return !_4.isEmpty(_4.find(this.ngMajorCurrentMajorsQuery.result, (major: MajorProgram) => major.id === id));
  }

  getMajor(id: number): MajorProgram {
    const source = this.isCurrentMajor(id) ? this.ngMajorCurrentMajorsQuery : this.ngMajorProgramsQuery;
    return _4.find(source.result, (major: MajorProgram) => major.id === id);
  }

  getMajorSalaryString(major: MajorProgram): string {
    const minSalary = _4.isNull(major.salary_trend_min_raw) ? 'N/A' : major.salary_trend_min;
    const maxSalary = _4.isNull(major.salary_trend_max_raw) ? 'N/A' : major.salary_trend_max;

    return minSalary === 'N/A' && maxSalary === 'N/A' ? 'N/A' : `${minSalary} - ${maxSalary}`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/services/major_service.ts